import { atom } from 'jotai';

import { itemUpdateAtom } from '../_graphql/mutationItemUpdate';
import { itemDetailQueryAtom } from '../_graphql/queryItemDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

// 🟣🟣🟣 PARAMS
export const $itemId = settingsRouteParamAtom(['/inventory/items/:id'], 'id');

// 🟢🟢🟢 REMOTE DATA
export const $remoteItemDetail = itemDetailQueryAtom((get) => {
  const itemId = get($itemId);
  return {
    variables: {
      ids: itemId ? [itemId] : [],
    },
    skip: !itemId,
  };
});

// 🟢🟢🟢 COMPUTED DATA
export const $isItemLoading = atom((get) => {
  const data = get($remoteItemDetail);
  return data?.isLoading ?? false;
});

export const $itemError = atom((get) => {
  const data = get($remoteItemDetail);
  return data?.error ?? null;
});

// 🔘🔘🔘 PLAIN ATOMS
export const $isEditDialogOpen = atom<boolean>(false);

// 🟠🟠🟠 ACTION -> UPDATE item
export const $updateItem = itemUpdateAtom({
  onSuccess: (get) => {
    get($remoteItemDetail).refetch?.();
  },
});
